module.exports = __webpack_public_path__ + "media/site/images/products/saas_oeetools-screen2@2x-e38765d502cdf0adcbc579517969060e.png";